// Models
import { AddressSearch } from '../models/address-search.interface';
import { GoogleAddress } from '../models/google-address.interface';

/**
 * Obtener elemento de dirección a partir de los componentes geocodificados de Google Maps.
 * @param addressComponents Componentes de dirección.
 * @param type Tipo de componente de dirección.
 * @returns Información del componente de dirección.
 * */
const getAddressItem = (
  addressComponents: google.maps.GeocoderAddressComponent[],
  type: string
): string => {
  const itemExists = addressComponents.find((value) =>
    value.types.includes(type)
  );
  return itemExists?.long_name || '';
};

/**
 * Obtener string de búsqueda de dirección.
 * @param params - Parámetros de búsqueda de dirección.
 */
const getAddressSearch = ({
  street,
  number,
  locality,
  country,
  administrativeAreaLevel3,
}: AddressSearch): string => {
  const formattedStreet = [street, number].filter(Boolean).join(' ');
  const formattedArea =
    locality === administrativeAreaLevel3
      ? [locality]
      : [locality, administrativeAreaLevel3];
  return [formattedStreet, ...formattedArea, country]
    .filter(Boolean)
    .join(', ');
};

/**
 * Obtener dirección a partir de los resultados de geocodificación de Google Maps.
 * @param geocoderResult - Resultado de geocodificación de Google Maps.
 */
export const getAddressFromGeocoderResult = (
  geocoderResult: google.maps.GeocoderResult
): GoogleAddress => {
  const { lat, lng } = geocoderResult.geometry.location.toJSON();
  const addressComponents = geocoderResult.address_components;
  console.log('addressComponents', addressComponents);
  const street = getAddressItem(addressComponents, 'route');
  const number = getAddressItem(addressComponents, 'street_number');
  const locality = getAddressItem(addressComponents, 'locality');
  const country = getAddressItem(addressComponents, 'country');

  const postalCode = getAddressItem(addressComponents, 'postal_code');

  // Comuna (CL) o Distrito (PE).
  const administrativeAreaLevel3 = getAddressItem(
    addressComponents,
    'administrative_area_level_3'
  );

  // Región (CL) o Departamento (PE).
  const administrativeAreaLevel1 = getAddressItem(
    addressComponents,
    'administrative_area_level_1'
  );

  const search = getAddressSearch({
    street,
    number,
    locality,
    country,
    administrativeAreaLevel3,
  });

  return {
    search,
    country,
    street,
    locality,
    administrativeAreaLevel1,
    administrativeAreaLevel3,
    number: Number(number),
    latitude: lat,
    longitude: lng,
    postalCode,
  };
};
